<template>
  <d2-container>
    <el-descriptions title="用户及收获信息" :column="3">
      <!-- <template slot="extra">
                <el-button type="text" size="small" @click="changeInfo">修改收货信息</el-button>
      </template>-->
      <!-- <el-descriptions-item label="用户昵称">{{user.shipName}}</el-descriptions-item> -->
      <el-descriptions-item
        label="手机号码"
        :contentStyle="{'color': 'rgb(70, 164, 241)'}"
      >{{user.shipMobile}}</el-descriptions-item>
      <el-descriptions-item label="收货人">{{user.shipName}}</el-descriptions-item>
      <el-descriptions-item label="收货人手机号码">{{user.shipMobile}}</el-descriptions-item>
      <el-descriptions-item label="收货地址">{{user.shipAddr}}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="父订单信息" :column="3">
      <el-descriptions-item label="父订单编号">kooriookami</el-descriptions-item>
      <el-descriptions-item
        label="支付交易单号"
        :contentStyle="{'color': 'rgb(70, 164, 241)'}"
      >18100000000</el-descriptions-item>
      <el-descriptions-item label="下单时间">{{user.createTime}}</el-descriptions-item>
      <el-descriptions-item label="付款时间">{{user.payTime}}</el-descriptions-item>
      <el-descriptions-item label="付款方式">{{user.payType === 1 ? '微信支付' :''}}</el-descriptions-item>
      <el-descriptions-item label="订单类型">普通商品</el-descriptions-item>
      <el-descriptions-item label="父订单状态">
        {{user.status == 0 ?'已关闭' : (user.status == 1) ? '待支付' : (user.status == 2) ? '未支付取消' :(user.status == 3) ? '已退款' :
        (user.status == 4) ? '待发货' :(user.status == 5) ? '待收货' :(user.status == 6) ? '已收货' :'已完成'}}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions :column="3">
      <el-descriptions-item label="订单来源" label-class-name="my-label">小程序</el-descriptions-item>
    </el-descriptions>
    <el-row class="table-row-transverse">
      <el-col :span="12">
        <span class="table-row-name" >优惠券名称:</span>
        <span class="table-row-content" style="cursor: pointer;" @click="getEdit(user)">{{user.couponName}}</span>
      </el-col>
       <el-col :span="12">
        <span class="table-row-name" >优惠券金额:</span>
        <span class="table-row-content">{{user.couponPrice}}</span>
      </el-col>
    </el-row>
    <el-row class="table-row clearfloat">
      <el-row class="table-row-transverse">
        <el-col :span="12">
          <span class="table-row-name">商品总价：</span>
          <span class="table-row-content">{{allTotalData.goodsTotalPrice}}</span>
        </el-col>
        <el-col :span="12">
          <span class="table-row-name">订单实付金额：</span>
          <span class="table-row-content">{{allTotalData.payPrice}}</span>
        </el-col>
      </el-row>
      <el-row class="table-row-transverse">
        <el-col :span="12">
          <span class="table-row-name">运费：</span>
          <span class="table-row-content">{{allTotalData.freightPrice}}</span>
        </el-col>
        <el-col :span="12">
          <span class="table-row-name">商品成本价：</span>
          <span class="table-row-content">{{allTotalData.costPrice}}</span>
        </el-col>
      </el-row>
      <el-row class="table-row-transverse">
        <el-col :span="12">
          <span class="table-row-name">微信支付：</span>
          <span class="table-row-content">{{allTotalData.mobilePosCount}}</span>
        </el-col>
        <el-col :span="12">
          <span class="table-row-name">毛利：</span>
          <span class="table-row-content">{{allTotalData.saleName}}</span>
        </el-col>
      </el-row>
    </el-row>
    <el-descriptions title="子订单信息1" :column="3">
      <el-descriptions-item label="子订单编号">{{userSon.itemNo}}</el-descriptions-item>
      <el-descriptions-item label="供应商名称">18100000000</el-descriptions-item>
      <el-descriptions-item label="子订单状态">
        {{userSon.status == 0 ?'已关闭' : (userSon.status == 1) ? '待支付' : (userSon.status == 2) ? '未支付取消' :(userSon.status == 3) ? '已退款' :
        (userSon.status == 4) ? '待发货' :(userSon.status == 5) ? '待收货' :(userSon.status == 6) ? '已收货' :'已完成'}}
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      size="small"
      :data="sonList"
      stripe
      border
      highlight-current-row
      style="max-width: 1920px"
    >
      <el-table-column align="center" label="skuId">
        <template slot-scope="scope">
          <span>{{scope.row.skuId}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="sku名称">
        <template slot-scope="scope">
          <span>{{scope.row.skuName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="购买数量">
        <template slot-scope="scope">
          <span>{{scope.row.count}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="单品优惠金额">
        <template slot-scope="scope">
          <span>{{scope.row.discountPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="邮费">
        <template slot-scope="scope">
          <span>{{scope.row.freightPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="子订单编号">
        <template slot-scope="scope">
          <span>{{scope.row.itemNo}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品原价(合计)" width="130">
        <template slot-scope="scope">
          <span>{{scope.row.originalPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="支付总额">
        <template slot-scope="scope">
          <span>{{scope.row.payPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="分摊优惠金额">
        <template slot-scope="scope">
          <span>{{scope.row.shareDiscountPrice}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="收货状态 ">
        <template slot-scope="scope">
          <span v-if="scope.row.shipStatus === 0" class="red">未发货</span>
          <span v-if="scope.row.shipStatus === 1" class="green">已发货</span>
          <span v-if="scope.row.shipStatus === 2" class="green">已签收</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="商品缩略图">
        <template slot-scope="scope">
          <img :src="scope.row.spuCover" style="width:60px;height:60px;object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="spuId">
        <template slot-scope="scope">
          <span>{{scope.row.spuId}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="spu名称">
        <template slot-scope="scope">
          <span>{{scope.row.spuName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="订单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0" class="grey">已关闭</span>
          <span v-if="scope.row.status === 1" class="red">待支付</span>
          <span v-if="scope.row.status === 2" class="red">未支付取消</span>
          <span v-if="scope.row.status === 3" class="green">已退款</span>
          <span v-if="scope.row.status === 4" class="red">待发货</span>
          <span v-if="scope.row.status === 5" class="red">待收货</span>
          <span v-if="scope.row.status === 6" class="green">已收货</span>
          <span v-if="scope.row.status === 7" class="green">已完成</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="旺店通编码">
        <template slot-scope="scope">
          <span>{{scope.row.wdNo}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注">
        <template slot-scope="scope">
          <span>{{scope.row.remark}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="table-row clearfloat">
      <el-row class="table-row-transverse">
        <el-col :span="12">
          <span class="table-row-name">商品总价：</span>
          <span class="table-row-content">{{allTotalData.payPrice}}</span>
        </el-col>
        <el-col :span="12">
          <span class="table-row-name">订单实付金额：</span>
          <span class="table-row-content">{{allTotalData.customerNo}}</span>
        </el-col>
      </el-row>
      <el-row class="table-row-transverse">
        <el-col :span="12">
          <span class="table-row-name">运费：</span>
          <span class="table-row-content">{{allTotalData.freightPrice}}</span>
        </el-col>
        <el-col :span="12">
          <span class="table-row-name">商品成本价：</span>
          <span class="table-row-content">{{allTotalData.isOwner}}</span>
        </el-col>
      </el-row>
      <el-row class="table-row-transverse">
        <el-col :span="12">
          <span class="table-row-name">微信支付：</span>
          <span class="table-row-content">{{allTotalData.mobilePosCount}}</span>
        </el-col>
        <el-col :span="12">
          <span class="table-row-name">毛利：</span>
          <span class="table-row-content">{{allTotalData.saleName}}</span>
        </el-col>
      </el-row>
    </el-row>
    <!-- <el-descriptions :title="orderRemark" :column="1" style="color:#5d9ee2">
            <el-descriptions-item>
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" disabled placeholder="请输入内容" v-model=""></el-input>
            </el-descriptions-item>
    </el-descriptions>-->
    <el-row>
      <el-col
        v-if="orderRemark"
        :span="24"
        style="background-color: whitesmoke;padding: 10px 20px 10px 10px;border-radius: 5px;"
      >
        <span style="color:#71adea;font-weight:bold;padding:0;font-size:16px">备注：</span>
        <span style="color:#71adea;font-weight:bold;padding:0">{{orderRemark}}</span>
      </el-col>
      <el-col
        v-else
        :span="24"
        style="background-color: whitesmoke;padding: 10px 20px 10px 10px;border-radius: 5px;text-align:center"
      >
        <span style="color:#71adea;font-weight:bold;padding:0;font-size:16px;">暂无备注</span>
      </el-col>
    </el-row>
    <div class="footer">
      <el-button @click="cancel('form')">取 消</el-button>
    </div>
    <el-dialog
      title="修改收货地址"
      center
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="收货人姓名:" prop="receiveName">
          <el-input v-model="ruleForm.receiveName" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收货人手机号:" prop="receivePhone">
          <el-input v-model="ruleForm.receivePhone" size="small"></el-input>
        </el-form-item>
        <el-form-item label="所在区域:" prop="provinceValue">
          <el-select v-model="ruleForm.provinceValue" placeholder="请选择" @change="selectProvimce">
            <el-option
              v-for="(item,index) of provincearr"
              :key="index"
              :label="item.name"
              :value="item.id"
              size="small"
            ></el-option>
          </el-select>
          <el-select v-model="ruleForm.cityValue" placeholder="请选择" @change="selectcity">
            <el-option
              v-for="(item,index) of cityarr"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-select placeholder="请选择" v-model="ruleForm.RegionValue">
            <el-option
              v-for="(item,index) of regionarr"
              :key="index"
              :label="item.name"
              :value="item.id"
              size="small"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址:" prop="detailAddress">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ruleForm.detailAddress"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureChange('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getOrderList, getDetailList } from '@/api/demo/order/index'
import { province } from '@/pages/demo/order/map'
export default {
  data () {
    return {
      sonList: [],
      id: '',
      allTotalData: {},
      user: {},
      userSon: {},

      dialogVisible: false,
      rules: {
        receiveName: [
          { required: true, message: '请填写收货人姓名', trigger: 'blur' }
        ],
        receivePhone: [
          { required: true, message: '请填写收货人手机号', trigger: 'blur' }
        ],
        provinceValue: [
          { required: true, message: '请选择所在区域', trigger: 'change' }
        ],
        detailAddress: [
          { required: true, message: '请填写详细地址', trigger: 'blur' }
        ]
      },
      ruleForm: {
        receiveName: '',
        receivePhone: '',
        provinceValue: '',
        cityValue: '',
        RegionValue: '',
        detailAddress: ''
      },
      arr: [1, 3, 4],
      province: [],
      cityarr: [],
      regionarr: [],
      orderRemark: '' // 订单备注
    }
  },
  created () {
    this.id = this.$route.query.id
    this.provincearr = province
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    getDetail () {
      let tableData = []
      getDetailList(this.id).then(res => {
        this.allTotalData = res
        if (res.couponName == null) {
          let key = 'couponName'
          let value = ''
          res[key] = value
        }
        this.user = res
        this.userSon = res.orderItems[0]
        tableData.push(res)
        console.log(res, 'tableData')
        this.sonList = res.orderItems
        this.orderRemark = JSON.parse(res.kefuRemark).remark
      })
    },
    // 点击修改收货信息
    changeInfo () {
      this.dialogVisible = true
      this.ruleForm = {}
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate() // 只清除清除验证
      })
    },
    handleClose () {
      this.dialogVisible = false
    },
    // 提交弹框
    sureChange (ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    selectProvimce (id) {
      this.cityarr = []
      this.regionarr = []
      this.cityValue = ''
      this.RegionValue = ''
      for (let item of this.provincearr) {
        if (id == item.id) {
          console.log(item)
          this.cityarr = item.children
        }
      }
    },
    selectcity (id) {
      this.regionarr = []
      this.RegionValue = ''
      for (let item of this.cityarr) {
        if (id == item.id) {
          this.regionarr = item.children
        }
      }
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/order')
    },
    getEdit (row) {
      // console.log("11");
      this.$router.push({
        path: '../../../demo/discount/addDiscount',
        query: {
          id: row.couponId,
          state: 1
        }
      })
    }
  }
}
</script>

<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
/deep/.el-descriptions__header {
  background-color: whitesmoke;
  padding: 10px 20px 10px 10px;
  border-radius: 5px;
}
.table-row {
  margin: 10px 0;
}
.table-row-transverse {
  border: 1px solid #ebeef5;
}
.table-row-title {
  width: 100%;
  text-align: center;
  color: #333;
}
span {
  display: inline-block;
  padding: 7px;
  font-size: 14px;
  color: #606266;
}
.table-row-name {
  background-color: #f5f7fa;
  width: 155px;
  text-align: right;
}
.table-row-content {
  margin-left: 20px;
}
.my-label {
  display: block;
}
/deep/.el-input--small .el-input__inner {
  width: 50%;
}
/deep/.el-form-item__content {
  display: flex;
}
/deep/.el-select {
  margin-right: 10px;
}
</style>
